export const CONNECTION_ERROR_MESSAGE =
  'Keine Verbindung zum Server. Bitte prüfe deine Internetverbindung.'
export const SERVER_ERROR_MESSAGE = 'Es ist etwas schiefgegangen. Bitte versuche es erneut.'

export type RequestFailureKind = 'connection' | 'server'

export class RequestFailed extends Error {
  readonly kind: RequestFailureKind

  constructor(kind: RequestFailureKind) {
    super(`request failed (${kind})`)
    this.name = 'RequestFailed'
    this.kind = kind
  }
}

export function requestFailureMessage(error: unknown): string {
  return isConnectionError(error) ? CONNECTION_ERROR_MESSAGE : SERVER_ERROR_MESSAGE
}

function isConnectionError(error: unknown): boolean {
  return error instanceof RequestFailed ? error.kind === 'connection' : error instanceof TypeError
}
